import React, { useEffect } from 'react'
import './creditAccountsModal.css'
import { CustomerContext } from 'state/context/CustomerFormContext'
import { FormatMoney, searchCompanyName } from 'Utils/functions'
import no from '../../../../Assets/Images/Login/no.svg'
import search from '../../../../Assets/Images/BuscarCotizacion/search.svg'
import eyeCorrect from '../../../../Assets/Images/Eyes/correct.svg'
import eyeWrong from '../../../../Assets/Images/Eyes/wrong.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { validateAmountOnCommercialCreditServices } from 'redux/services/mdl14Services'
import { sleep } from 'Utils/Helpers/fakeTimers'
import { companiesCodeOracle } from 'Utils/constants'

export const CreditAccountsModal = ({ customerId, setShowCreditAccounts }) => {
  const { creditAccounts } = CustomerContext()
  const [textSearch, setTextSearch] = React.useState('')
  const [showClearSearch, setShowClearSearch] = React.useState(false)
  const [allCreditAccounts, setAllCreditAccounts] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [allDataToSearch, setAllDataToSearch] = React.useState([])

  const getAllCreditAccounts = async () => {
    try {
      setLoading(true)
      const allCreditAccounts = []
      const signatures = []
      let hasAtLeastOneValidAccount = false

      for (const account of creditAccounts) {
        try {
          const companyCode =
            companiesCodeOracle[account.CompanyId.toUpperCase()] || '01'

          const response = await validateAmountOnCommercialCreditServices({
            product: 'oracle-credit-commercial-customer',
            no_cia: companyCode,
            no_cliente: account.CreditAccountNumber,
          })

          const Data = response?.data?.Data ?? response
          const allImages = Data?.firmas
            ?.map(item => item?.imagen)
            ?.slice(0, creditAccounts?.length)
          if (signatures.length === 0 && allImages?.length !== 0) {
            for (const image of allImages) {
              const img = new Image()
              img.src = image
              img.onload = () => {
                signatures.push({ icon: eyeCorrect, url: image })
              }
              img.onerror = () => {
                signatures.push({ icon: eyeWrong, url: null })
              }
            }
          }
          if (allImages?.length <= 1) {
            await sleep(2000)
          }

          // Si tiene datos válidos (cuentas)
          if (Data?.cuentas?.[0]) {
            hasAtLeastOneValidAccount = true
            allCreditAccounts.push({
              ...Data?.cuentas?.[0],
              company: searchCompanyName(account),
              hasValidData: true,
            })
          }
          // Si no tiene cuentas pero tiene resultado.codigo === 99
          else if (Data?.resultado?.codigo === 99) {
            allCreditAccounts.push({
              no_cliente: account.CreditAccountNumber,
              company: searchCompanyName(account),
              hasValidData: false,
              isCode99: true,
            })
          }
          // Si Data es null/undefined o no cumple ninguna condición, no se incluye
        } catch (accountError) {
          console.log('Error processing account:', account, accountError)
          // Continuar con la siguiente cuenta aunque esta falle, pero no agregar al array
        }
      }

      // Si todas tienen código 99 (ninguna tiene datos válidos), dejar el arreglo vacío
      let finalCreditAccounts = []
      if (hasAtLeastOneValidAccount) {
        // Si al menos una tiene datos válidos, incluir todas (válidas y código 99)
        finalCreditAccounts = allCreditAccounts
      } else {
        // Si ninguna tiene datos válidos, arreglo vacío
        finalCreditAccounts = []
      }

      const newAllCreditAccounts = finalCreditAccounts.map((item, index) => {
        return {
          ...item,
          signature: signatures[index] || { icon: eyeWrong, url: null },
        }
      })

      setAllCreditAccounts(newAllCreditAccounts)
      setAllDataToSearch(newAllCreditAccounts)
    } catch (error) {
      console.log('getAllCreditAccountsError -->', error)
    } finally {
      setLoading(false)
    }
  }

  const handleLocalSearch = textSearch => {
    const newAllCreditAccounts = allDataToSearch.filter(item => {
      return (
        item?.no_cliente
          ?.toString()
          ?.toLowerCase()
          .includes(textSearch.toLowerCase()) ||
        item?.nombre?.toLowerCase().includes(textSearch.toLowerCase()) ||
        item?.company?.toLowerCase().includes(textSearch.toLowerCase())
      )
    })
    setAllCreditAccounts(newAllCreditAccounts)
  }

  useEffect(() => {
    getAllCreditAccounts()
  }, [])

  return (
    <div className="customer-credits-account-modal-wrapper">
      <div className="new-table-wrapper">
        <div className="customer-credits-account-modal-header">
          <h2 className="customer-credits-account-modal-title">
            Cuentas crédito
          </h2>
          <img
            src={no}
            alt="close"
            className="customer-credits-account-modal-close"
            onClick={() => setShowCreditAccounts(false)}
          />
        </div>
        <div className="customer-credits-account-modal-search-wrapper">
          <div className="customer-credits-account-modal-search">
            <input
              type="text"
              placeholder="Filtrado de la lista"
              disabled={loading}
              value={textSearch}
              onChange={e => setTextSearch(e.target.value?.trim())}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  handleLocalSearch(textSearch)
                  setShowClearSearch(textSearch !== '')
                }
              }}
            />
            <div className="customer-credits-account-modal-search-icon">
              {loading ? (
                <FontAwesomeIcon
                  icon={faSpinner}
                  className="spinner seach-spinner"
                  style={{ fontSize: 20 }}
                />
              ) : (
                <img
                  src={search}
                  alt="search-icon"
                  onClick={() => {
                    handleLocalSearch(textSearch)
                    setShowClearSearch(textSearch !== '')
                  }}
                />
              )}
            </div>
          </div>
          {showClearSearch && (
            <button
              className="customer-credits-account-modal-button"
              onClick={() => {
                getAllCreditAccounts(customerId)
                setTextSearch('')
                setShowClearSearch(false)
              }}>
              Traer todos
            </button>
          )}
        </div>
        <div className="new-table-container" style={{ overflow: 'auto' }}>
          <table className="new-table-container-table">
            <thead>
              <tr>
                <th>Cuenta</th>
                <th>Descripción</th>
                <th>Compañía</th>
                <th>Límite de crédito</th>
                <th>Saldo adeudado</th>
                <th>Crédito caducado</th>
                <th>Cuenta exenta</th>
                <th>Firma autorizada</th>
              </tr>
            </thead>
            <tbody>
              {allCreditAccounts?.map(item => {
                const hasData = item.nombre !== undefined
                const renderBadge = (value, yesValue) => {
                  if (!hasData) return 'Sin Información'
                  return value === yesValue ? (
                    <p className="single-product-cart-a-badge yes">Si</p>
                  ) : (
                    <p className="single-product-cart-a-badge no">No</p>
                  )
                }

                return (
                  <tr className="new-table-content-row" key={item.no_cliente}>
                    <td className="new-table-content-col">{item.no_cliente}</td>
                    <td className="new-table-content-col">
                      {item.nombre || 'Sin Información'}
                    </td>
                    <td className="new-table-content-col">
                      {item.company || 'Sin Información'}
                    </td>
                    <td className="new-table-content-col">
                      {hasData
                        ? '$' + FormatMoney(item.limite, true, 2)
                        : 'Sin Información'}
                    </td>
                    <td className="new-table-content-col">
                      {hasData
                        ? '$' + FormatMoney(item.saldo, true, 2)
                        : 'Sin Información'}
                    </td>
                    <td className="new-table-content-col">
                      {renderBadge(item.bloqueado, true)}
                    </td>
                    <td className="new-table-content-col">
                      {renderBadge(item.exento !== 'N', true)}
                    </td>
                    <td className="new-table-content-col">
                      {item?.signature?.url ? (
                        <a
                          href={item.signature.url}
                          style={{ cursor: 'pointer' }}
                          target="_blank"
                          rel="noreferrer">
                          <img src={item.signature.icon} alt="signature" />
                        </a>
                      ) : item?.signature?.icon ? (
                        <img src={item.signature.icon} alt="signature" />
                      ) : (
                        'Sin Información'
                      )}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          {!allCreditAccounts?.length && !loading && (
            <div className="customer-credits-account-modal-empty">
              No se encontraron registros.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
